// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createVendorInvites = (client) => ({
    /**
     * `POST /vendor/invites/accept`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorAcceptInvite
     * @source packages/modules/b2c-core/src/api/vendor/invites/accept/route.ts
     */
    accept: (body, query, headers) => client.fetch("/vendor/invites/accept", { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/invites`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorCreateInvite
     * @source packages/modules/b2c-core/src/api/vendor/invites/route.ts
     */
    create: (body, query, headers) => client.fetch("/vendor/invites", { method: "POST", body, query, headers }),
    /**
     * `GET /vendor/invites`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorListInvites
     * @source packages/modules/b2c-core/src/api/vendor/invites/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/invites", { method: "GET", query, headers }),
});
//# sourceMappingURL=invites.js.map